import {
  startOfWeek,
  addWeeks,
  endOfWeek,
  subWeeks,
  startOfMonth,
  addMonths,
  endOfMonth,
  subMonths,
  startOfYear,
  addYears,
  endOfYear,
  subYears,
  startOfDay,
  addDays,
  endOfDay,
  subDays,
} from '@e3dc-react/shell/Libs/date'
import { ChartDateRangeView } from '../../models/dashboard.model'
import { Moment } from '@e3dc-react/shell/Libs/moment'

interface Dates {
  onNextStartDate: Date
  onNextEndDate: Date
  onPreviousStartDate: Date
  onPreviousEndDate: Date
  startOfDate: Date
  endOfDate: Date
}

/**
 * Function for getting proper date format based on chart view using date-fns logic
 * date-fns have different way how handles start and end of week, month, year
 * It also has logic for formatting dates based on next and previous clicks, adding or subtracting weeks, months and years
 */
export const getDates = (date: Date | Moment, view: ChartDateRangeView): Dates => {
  const clonedDate = new Date(String(date))

  if (view === 'week') {
    return {
      onNextStartDate: startOfWeek(addWeeks(clonedDate, 1), { weekStartsOn: 1 }),
      onNextEndDate: endOfWeek(addWeeks(clonedDate, 1), { weekStartsOn: 1 }),
      onPreviousStartDate: startOfWeek(subWeeks(clonedDate, 1), { weekStartsOn: 1 }),
      onPreviousEndDate: endOfWeek(subWeeks(clonedDate, 1), { weekStartsOn: 1 }),
      startOfDate: startOfWeek(clonedDate, { weekStartsOn: 1 }),
      endOfDate: endOfWeek(clonedDate, { weekStartsOn: 1 }),
    }
  }

  if (view === 'month') {
    return {
      onNextStartDate: startOfMonth(addMonths(clonedDate, 1)),
      onNextEndDate: endOfMonth(addMonths(clonedDate, 1)),
      onPreviousStartDate: startOfMonth(subMonths(clonedDate, 1)),
      onPreviousEndDate: endOfMonth(subMonths(clonedDate, 1)),
      startOfDate: startOfMonth(clonedDate),
      endOfDate: endOfMonth(clonedDate),
    }
  }

  if (view === 'day') {
    return {
      onNextStartDate: startOfDay(addDays(clonedDate, 1)),
      onNextEndDate: endOfDay(addDays(clonedDate, 1)),
      onPreviousStartDate: startOfDay(subDays(clonedDate, 1)),
      onPreviousEndDate: endOfDay(subDays(clonedDate, 1)),
      startOfDate: startOfDay(clonedDate),
      endOfDate: endOfDay(clonedDate),
    }
  }

  return {
    onNextStartDate: startOfYear(addYears(clonedDate, 1)),
    onNextEndDate: endOfYear(addYears(clonedDate, 1)),
    onPreviousStartDate: startOfYear(subYears(clonedDate, 1)),
    onPreviousEndDate: endOfYear(subYears(clonedDate, 1)),
    startOfDate: startOfYear(clonedDate),
    endOfDate: endOfYear(clonedDate),
  }
}
